import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";

const SearchByIMEIModel = {
  getDivisions: (countryCode) => {
    return modelBaseV2.get("/api/codemaster/divisionGroup", {
      params: { countryCode },
    });
  },

  getStatuses: () => {
    return modelBaseV2.get("/api/codemaster/selloutStatus", {
      params: { countryCode: "" },
    });
  },

  search: (criteria = {}) => {
    return modelBaseV2.post("/api/report/imeichecklist", {
      body: criteria,
    });
  },

  exportSearchResultToExcel: (config = {}) => {
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      inputUserID: "7",
      fromDate: "8",
      toDate: "9",
      inputCountryCode: "16",
      inputUserLanguageCode: "17",
      status: "23",
      sortBy: "24",
      imei: "101",
      modelCodes: "115",
      divisionGroup: "117",
      location: "118",
      channel: "119", // Site in UI
    };

    const params = Object.entries(paramsMapping).map(([param, code]) => {
      const arg = config[param];
      return {
        code,
        value: arg?.toString() || "",
      };
    });

    const exportConfig = {
      excelSheetNames: ["Result"],
      storedProcedureCode: "56",
      params,
    };

    return modelBaseV2.postDownload(
      "/api/executesp/export/commonexcel",
      {
        body: exportConfig,
      },
      `Search_By_IMEI_No_Result_${moment().format("YYYYMMDDhhmm")}.xlsx`,
    );
  },
};

export default SearchByIMEIModel;